<template>
    <div class="sidebar__section sidebar__section--border-top-huge login-teaser ui-center-vertically" @click="openLoginMenuClickHandler">
        <div class="login-teaser__profile ui-center-content">
            <Icon :size="20">
                <IconProfile />
            </Icon>
        </div>
        <div class="login-teaser__content">
            <div class="h3-bold">Jetzt gratis anmelden</div>
            <div class="copy">und von vielen Vorteilen profitieren</div>
        </div>
        <Icon class="login-teaser__arrow">
            <IconChevronRight />
        </Icon>
    </div>
</template>

<script>
import eventBus from '@/utils/event-bus';
import Icon from '@/components/Icon.vue'
import IconChevronRight from '@/components/icons/IconChevronRight.vue'
import IconProfile from '@/components/icons/IconProfile.vue'

export default {
    components: {
        Icon,
        IconChevronRight,
        IconProfile
    },
    methods: {
        openLoginMenuClickHandler() {
            eventBus.$emit('showLoginMenu');
        },
    },
}
</script>

<style lang="scss">
.login-teaser {
    padding-top: 18px;
    padding-bottom: 18px;
    gap: 12px;
    transition: $link-transition;
    cursor: pointer;

    @include mq(tablet) {
        padding-top: 24px;
    padding-bottom: 24px;
    }

    .no-touch &:hover {
        background: $color-black-003;
    }

    &__profile {
        width: 40px;
        height: 40px;
        background: $color-yellow;
        border-radius: 100%;
        flex-shrink: 0;
    }

    &__arrow {
        margin-left: auto;
        color: $color-grey;
    }
}
</style>